module.exports = __webpack_public_path__ + "assets/img/5-6.e50d5fe1.png";